/**
 * The revision of the recurring terms' words (card-rules block 4.1) a person agrees to (design §32.22.2). Stored in
 * `recurring_charge_consent.text_revision`, whose CHECK is `^[a-z0-9][a-z0-9-]{2,62}$` (migration 0159).
 */
export const RECURRING_CHARGE_CONSENT_TEXT_REVISION = "recurring-terms-2026-10-16";
/**
 * What a recurring charge consent was given for (`recurring_charge_consent.purpose`, migration 0159; design §32.22.2):
 * a first purchase, a reactivation, an upgrade (the consent is asked again, OD-13) or a card replacement (a new
 * cardholder-initiated recurring charge on the new card, ED-23).
 */
export const RECURRING_CHARGE_CONSENT_PURPOSE = ["purchase", "reactivation", "upgrade", "card_replacement"];
const RECURRING_CHARGE_CONSENT_PURPOSE_SET = new Set(RECURRING_CHARGE_CONSENT_PURPOSE);
/** Reads one consent purpose, throwing on anything else (design §32.20: "an unknown … consent purpose throws"). */
export function recurringChargeConsentPurposeOf(value) {
    if (typeof value !== "string" || !RECURRING_CHARGE_CONSENT_PURPOSE_SET.has(value)) {
        throw new RangeError(`${JSON.stringify(value)} is not a recurring charge consent purpose (one of ${RECURRING_CHARGE_CONSENT_PURPOSE.join(", ")})`);
    }
    return value;
}
//# sourceMappingURL=offer.js.map